export default __webpack_public_path__ + "static/img4-e6ed7c42f8f7d26ff429414bc85d88b2.png";